import { Input, NumericInput } from "Components/Form/Input";
import { RadioButton, RadioButtonTrueFalse } from "Components/Form/RadioButton";
import {
  disabilityPensionFormElementsActive,
  incomeDependencyOrDebtResponsibleFormElementsActive,
} from "./activeFormElements";
import {
  getDebtResponsibleOptions,
  getDisabilityPensionOptions,
  getEconomicalHealthWishOptions,
  getEconomicalSituationOptions,
  getIncomeDependencyOptions,
} from "./formElementsOptions";

import { InputMode } from "Components/Form/Input/inputTypes";
import { Select } from "Components/Form/Select";
import { VALUE_TYPE } from "Components/NumberValue";
import { useIsAdvisorSelector } from "Store/advisor/advisorSelectors";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import React from "react";
import { CoInsuredFormElements } from "./CoInsuredFormElements";
import { AdviceProductDetailsFormValues } from "./interfaces";
import { FormGroupWrap } from "./styled";

interface Props {
  formProps: FormikProps<AdviceProductDetailsFormValues>;
  formText: any;
  lang: string;
}
export const EconomyFormElements = ({
  formProps,
  formText,
  lang,
}: Props): React.ReactElement => {
  const isAdvisor = useIsAdvisorSelector();
  const aboutYou = formText.aboutYou;

  return (
    <>
      <FormGroupWrap>
        <NumericInput
          large
          id="income"
          name="income"
          label={aboutYou.income.label[lang]}
          hint={aboutYou.income.hint[lang]}
          inputMode={InputMode.NUMERIC}
          suffix={VALUE_TYPE.NOK}
          error={getError("income", formProps)}
          inputProps={{ autoComplete: isAdvisor ? "off" : undefined }}
        />
        {incomeDependencyOrDebtResponsibleFormElementsActive(
          formProps.values.familySituation,
          formProps.values.income,
        ) && (
          <RadioButtonTrueFalse
            name="incomeDependency"
            id="incomeDependency"
            hint={aboutYou.incomeDependency.hint[lang]}
            label={aboutYou.incomeDependency.label[lang]}
            options={getIncomeDependencyOptions(
              aboutYou.incomeDependency.options,
              lang,
            )}
            direction="vertical"
            error={getError("incomeDependency", formProps)}
          />
        )}
      </FormGroupWrap>
      <FormGroupWrap>
        <NumericInput
          large
          id="debt"
          name="debt"
          label={aboutYou.debt.label[lang]}
          hint={aboutYou.debt.hint[lang]}
          inputMode={InputMode.NUMERIC}
          suffix={VALUE_TYPE.NOK}
          error={getError("debt", formProps)}
          inputProps={{ autoComplete: isAdvisor ? "off" : undefined }}
        />
        {incomeDependencyOrDebtResponsibleFormElementsActive(
          formProps.values.familySituation,
          formProps.values.debt,
        ) && (
          <RadioButton
            name="debtResponsible"
            id="debtResponsible"
            hint={aboutYou.debtResponsible.hint[lang]}
            label={aboutYou.debtResponsible.label[lang]}
            options={getDebtResponsibleOptions(
              formProps.values.familySituation,
              aboutYou.debtResponsible.options,
              lang,
            )}
            direction="vertical"
            error={getError("debtResponsible", formProps)}
          />
        )}
      </FormGroupWrap>
      {disabilityPensionFormElementsActive(formProps.values.workSituation) && (
        <FormGroupWrap>
          <Select
            large
            id="disabilityPension"
            name="disabilityPension"
            label={aboutYou.disabilityPension.label[lang]}
            hint={aboutYou.disabilityPension.hint[lang]}
            options={getDisabilityPensionOptions(
              aboutYou.disabilityPension.options,
              lang,
            )}
            error={getError("disabilityPension", formProps)}
          />
        </FormGroupWrap>
      )}
      <RadioButton
        name="economicalSituation"
        id="economicalSituation"
        hint={aboutYou.economicalSituation.hint[lang]}
        label={aboutYou.economicalSituation.label[lang]}
        options={getEconomicalSituationOptions(
          aboutYou.economicalSituation.options,
          lang,
        )}
        direction="vertical"
        error={getError("economicalSituation", formProps)}
      />
      <RadioButton
        name="economicalHealthWish"
        id="economicalHealthWish"
        hint={aboutYou.economicalHealthWish.hint[lang]}
        label={aboutYou.economicalHealthWish.label[lang]}
        options={getEconomicalHealthWishOptions(
          aboutYou.economicalHealthWish.options,
          lang,
        )}
        direction="vertical"
        error={getError("economicalHealthWish", formProps)}
      />
      <CoInsuredFormElements formProps={formProps} />
      {isAdvisor && (
        <div className="data-hj-suppress">
          <Input
            id="situationComment"
            name="situationComment"
            label={aboutYou.situationComment.label[lang]}
            hint={aboutYou.situationComment.hint[lang]}
            as={"textarea"}
            fluid
            rows={3}
            error={getError("situationComment", formProps)}
            inputMode={InputMode.TEXT}
          />
        </div>
      )}
    </>
  );
};
